/* eslint-disable react/no-access-state-in-setstate */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import '../../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormControl } from 'react-bootstrap';
import { FilterPanel } from '../utils/FilterPanel';
import { MIN_FILTER_LENGTH } from '../../infrastructure/constants/common';
import CSVLinkButton from '../utils/CSVLinkButton';
import { USERS_CSV_HEADERS } from '../../infrastructure/constants/users';
import {
  StyledFilterFormGroup,
  StyledFilterTitle,
  StyledFilterWrapper,
} from '../utils/Styles/FilterStyles';

const filteredDataInitial = {
  email: '',
  name: '',
  phone: '',
  onlyAdmin: false,
  onlyVendor: false,
};

const intialState = {
  filteredData: filteredDataInitial,
  filter: 'all',
  isSuccsess: false,
  isError: false,
  isDeactive: false,
  csvUsers: [],
};

export default class FilterUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = intialState;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.filters = [
      { label: 'All Users', name: 'all' },
      { label: 'Only Admins', name: 'ADMIN' },
      { label: 'Only Vendors', name: 'VENDOR' },
    ];
  }

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterData } = this.props;
    if (filterData) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types

      let filter = 'all';
      // eslint-disable-next-line react/prop-types
      if (filterData.onlyAdmin) {
        filter = 'ADMIN';
      }

      // eslint-disable-next-line react/prop-types
      if (filterData.onlyVendor) {
        filter = 'VENDOR';
      }

      this.setState({ filteredData: filterData, filter });
    }
  }

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  hideMessage = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { isDeactive } = this.state;
    if (!isDeactive) {
      this.setState({ isError: false });
    }
  };

  handleFilterChange = ({ target }) => {
    const { name, value } = target;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filteredData } = this.state;
    const newFilteredData = { ...filteredData, [name]: value };
    this.setState({ ...this.state, filteredData: newFilteredData });
    if (target.value.length >= MIN_FILTER_LENGTH || target.value.length === 0) {
      this.handleSubmit(newFilteredData);
    }
  };

  changeFilter = filter => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    let { filteredData } = this.state;
    switch (filter) {
      case 'ADMIN': {
        filteredData = {
          ...filteredData,
          onlyAdmin: true,
        };
        break;
      }
      case 'VENDOR': {
        filteredData = {
          ...filteredData,
          onlyAdmin: false,
          onlyVendor: true,
        };
        break;
      }
      default: {
        filteredData = {
          ...filteredData,
          onlyAdmin: false,
          onlyVendor: false,
        };
      }
    }
    this.setState({ filteredData, filter });
    this.handleSubmit(filteredData);
  };

  handleSubmit = async filteredData => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterUsers } = this.props;
    filterUsers(filteredData);
  };

  render() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filteredData, filter } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { isMobileFilterSelected, csvUsers, loadCSVUsers } = this.props;
    return (
      <Fragment>
        <div
          className={`form-content filter-form ${
            isMobileFilterSelected ? 'mobile-filter-selected' : ''
          }`}
          style={{ paddingLeft: '0px' }}
        >
          <StyledFilterTitle>Filters</StyledFilterTitle>
          <StyledFilterWrapper>
            <FilterPanel
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              filters={this.filters}
              currentFilter={filter}
              onFilterChange={this.changeFilter}
            />
            <StyledFilterFormGroup>
              <FormControl
                type='text'
                placeholder='Email (3 characters min)'
                onChange={this.handleFilterChange}
                value={filteredData.email}
                name='email'
              />
            </StyledFilterFormGroup>
            <StyledFilterFormGroup>
              <FormControl
                type='text'
                placeholder='Name (3 characters min)'
                onChange={this.handleFilterChange}
                value={filteredData.name}
                name='name'
              />
            </StyledFilterFormGroup>
            <StyledFilterFormGroup>
              <FormControl
                type='text'
                placeholder='Phone (3 characters min)'
                onChange={this.handleFilterChange}
                value={filteredData.phone}
                name='phone'
              />
            </StyledFilterFormGroup>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              <CSVLinkButton
                data={[
                  {
                    id: 1,
                    items: csvUsers,
                    headers: USERS_CSV_HEADERS,
                    fileName: 'users.csv',
                  },
                ]}
                filterData={filteredData}
                style={{ marginTop: 0 }}
                loadData={loadCSVUsers}
              />
            }
          </StyledFilterWrapper>
        </div>
      </Fragment>
    );
  }
}
